import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import Routes from "./routes";
import muiTheme from './theme/muiTheme';
import GlobalStyle from './theme/GlobalStyle';

const App = () => {
  return (
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      <GlobalStyle />
      <Routes />
    </ThemeProvider>
  );
};

export default App;
